<div class="progress-circle" [attr.data-percentage]="percentage">
  <span class="progress-left">
    <span class="progress-bar"></span>
  </span>
  <span class="progress-right">
    <span class="progress-bar"></span>
  </span>
  <div class="progress-value">
    <div>
      {{ percentage | number: '1.0-0' }}
    </div>
  </div>
</div>
